import { Button, ButtonTheme } from 'components/Button';
import { TextField } from 'components/Field/TextField';
import { ICONS } from 'components/Icon';
import { Logo } from 'components/Logo';
import { useSelector } from 'hooks/useSelector';
import * as React from 'react';
import { useState } from 'react';
import { View } from 'react-native';
import { useDispatch } from 'react-redux';
import { AUTHENTICATE, doAuthHideAuthModal } from 'store/actions';
import {
  selectAuthToken,
  selectUserId,
  selectUserReference,
} from 'store/auth/selectors';

import { Card } from 'components/Card';
import { CardRow } from 'components/CardRow';
import { styles } from './styles';
import { UserChip } from './UserChip';

export const Email: React.FC = () => {
  const dispatch = useDispatch();
  const authorizationToken = useSelector(selectAuthToken);
  const [email, setEmail] = useState<string>('');
  const userId = useSelector(selectUserId);
  const userReference = useSelector(selectUserReference);

  const handleCancel = () => dispatch(doAuthHideAuthModal());
  const handleSubmit = () => {
    if (authorizationToken) {
      dispatch(AUTHENTICATE.request({ id: userId || userReference || '' }));
    } else if (email) {
      dispatch(AUTHENTICATE.request({ email }));
    }
  };

  if (authorizationToken) {
    return (
      <>
        <View style={styles.logo}>
          <UserChip />
        </View>
        <Card style={styles.textFieldContainer}>
          <CardRow
            label="Please confirm your details to continue using RiskBase"
            labelNumberOfLines={0}
          />
        </Card>
        <View style={styles.buttonContainer}>
          <Button
            buttonTheme={ButtonTheme.secondary}
            onPress={handleCancel}
            text="Cancel"
            marginRight
          />
          <Button
            icon={ICONS.ChevronRightSolid}
            onPress={handleSubmit}
            text="Next"
          />
        </View>
      </>
    );
  }

  return (
    <>
      <View style={styles.logo}>
        <Logo width={152} />
      </View>
      <Card
        label="Please enter your email address"
        style={styles.textFieldContainer}
      >
        <TextField
          placeholder="Your Email"
          onChange={setEmail}
          autoComplete="email"
          inputMode="email"
          autoCapitalize="none"
          autoCorrect={false}
          onSubmitEditing={handleSubmit}
          returnKeyType="next"
          onChangeDebounceMs={0}
          value={email}
          // Will re-focus field if an API error comes back
          autoFocusEveryRender
        />
      </Card>
      <View style={styles.buttonContainer}>
        <Button
          disabled={!email}
          icon={ICONS.ChevronRightSolid}
          onPress={handleSubmit}
          text="Next"
        />
      </View>
    </>
  );
};
